import { http } from '../../config/axios'

export default function putRepresentante(representante: any): Promise<string> {
  return http
    .put('api/representante', representante)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put representante', error)
      throw Error(error.response.data)
    })
}
